import { ModalContent, type StackProps } from '@chakra-ui/react';

export type UiModalContentProps = StackProps;

export const UiModalContent = ModalContent;
